import { useTranslation } from 'react-i18next';
import { fadeWithKey } from '../animations/textAnimation';
import ThemeProvider, { useTheme } from '../hooks/themeProvider';
import SkipLink from '../components/skipLink/skipLink';
import CursorFollower from '../components/cursorFollower/cursorFollower';
import LangButton from '../components/langButton/langButton';
import ThemeToggle from '../components/themeToggle/themeToggle';
import Header from '../components/header/header';
import Social from '../components/social/social';
import CopyRight from '../components/copyRight/copyRight'
import '../styles/global.css';
import './layout.css';

function LayoutContent({ children }) {
  const { i18n } = useTranslation();
  const { theme } = useTheme(); 
  const animationKey = `${i18n.language}-${theme}`;

  return (
    <div className='layout'>
      <div className='top'>
        <div className='top-inner'>
          <LangButton />
          <ThemeToggle />
        </div>
      </div>
      <Header />
      <main id='main'>
        {fadeWithKey(children, animationKey)}
      </main>
      <Social />
      <CopyRight />
    </div>
  );
}

export default function Layout({ children }) {
  return (
    <ThemeProvider>
      <CursorFollower />
      <SkipLink />
      <LayoutContent>
        {children}
      </LayoutContent>
    </ThemeProvider>
  );
}
